import { FC } from "react";
import { SearchSelectInput } from "components";
import lodash from "lodash";

export const ComplaintCategories = [
  {
    _id: "65292342758f1ad6d0fb4731",
    code: "CC00",
    type: "ComplaintType",
    name: "General",
  },
  {
    _id: "65292342758f1ad6d0fb4732",
    code: "CC01",
    type: "ComplaintType",
    name: "CustomerService",
  },
  {
    _id: "65292342758f1ad6d0fb4733",
    code: "CC02",
    type: "ComplaintType",
    name: "Commercial",
  },
  {
    _id: "65292342758f1ad6d0fb4734",
    code: "CC03",
    type: "ComplaintType",
    name: "Technical",
  },
  {
    _id: "65292342758f1ad6d0fb4735",
    code: "CC04",
    type: "ComplaintType",
    name: "RevenueProtection",
  },
  {
    _id: "65292342758f1ad6d0fb4736",
    code: "CC05",
    type: "ComplaintType",
    name: "Operations",
  },
];

interface ComplaintCategoryPickerProps {
  id: string;
  label?: string;
  isNonServicePoint?: boolean;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  setFieldTouched?: any;
  setFieldError?: any;
  rawId?: boolean;
  position?: "top" | "bottom";
}

// {
//   "_id": "65292342758f1ad6d0fb4731",
//   "code": "CC00",
//   "type": "ComplaintType",
//   "name": "General"
// },

const ComplaintCategoryPicker: FC<ComplaintCategoryPickerProps> = ({
  id,
  label,
  isNonServicePoint,
  rawId,
  ...form
}) => {
  return (
    <SearchSelectInput
      id={id ?? "activity"}
      label={label ?? ""}
      placeholder='Select Complaint Category'
      options={ComplaintCategories?.filter(
        (complaint) =>
          ["General", "Operations", "RevenueProtection"].includes(
            complaint.name
          ) || !isNonServicePoint
      )?.map((complaint) => ({
        label: {
          title: lodash.startCase(complaint.name) as string,
        },
        value: rawId ? complaint?.name : complaint,
      }))}
      {...form}
      disabled={form.disabled}
    />
  );
};

export default ComplaintCategoryPicker;
